// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react'

// mobx
import { observer } from 'mobx-react'

// fragments
import { fragments } from 'services/get-fragments'

// react-router
import { Link } from 'react-router-dom'

// semantic-ui
import { Header, Segment, Container, Image, Button } from 'semantic-ui-react'

export const HomePage = observer(() => (
  <>
    <Segment vertical textAlign='center' style={{ color: '#3c3c3c', backgroundColor: '#dddddd', padding: '40px 0px', margin: '0px !important' }}>
      <Image src='/custom-content/home-logo.png' style={{ margin:'-35px 5px -60px auto', height:'61px' }}/>
      <Image centered size='small' src='/custom-content/home-image.png' />
      <Header as='h2' style={{ color: '3c3c3c', margin:'-10px auto 0 auto' }}>放射線モニタリングプラットフォーム</Header>
      <p style={{ margin:'0 0 -20px 0', fontSize: 'large' }}>Radiation Monitoring Platform</p>
      <Header as='h1' style={{ color: '3c3c3c' }}>{fragments.Home.header}</Header>
      <p>{fragments.Home.tagline}</p>
      <Link to='/getting-started' data-testid='gettingStartedLink'>
        <Button positive>{fragments.Home.gettingStartedButton}</Button>
      </Link>
    </Segment>
    <Segment vertical style={{ padding: '40px 0px', margin: '0 !important' }}>
      <Container fluid text textAlign='justified'>
        <fragments.Home.jsx />
      </Container>
    </Segment>
  </>
))

export default HomePage
